import { Brick, BrickContext, registerBrick, Query } from 'olympe';
import System from "../../../models/System";
import Component from "../../../models/Component";
import Inspection from "../../../models/Inspection";

export default class MobileLoadSystem extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} system
     * @param {function()} forwardEvent
     * @param {function(*)} setLoadedSystem
     */
    async update($, [system], [forwardEvent, setLoadedSystem]) {
        const components = Query.from(system)
            .follow(System.allComponentsRel)
            .andReturn()
            .execute();
        const inspections = Query.from(system)
            .follow(System.allComponentsRel)
            .follow(Component.inspectionsRel).andReturn()
            .follow(Inspection.evaluationsListRel, true).andReturn()
            .execute();
        const rootComponents = Query.from(system)
            .andReturn()
            .follow(System.componentsRel)
            .execute();
        const subComponents = Query.from(system)
            .andReturn()
            .follow(System.allComponentsRel)
            .follow(Component.subComponentsRel)
            .execute();

        // Keep them in cache, avoid garbage collection until clear of this brick:
        const results = await Promise.all([components, inspections, rootComponents, subComponents])
        const key = `loaded_system_${system.getTag()}`;
        $.set(key, results);
        $.onClear(() => $.remove(key));

        setLoadedSystem(system);
        forwardEvent();
    }
}

registerBrick('018bcd6bb01b8754d4c0', MobileLoadSystem);
